import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../api.js';
import { useI18n } from '../../i18n/index.jsx';
import { Alert } from '../../components/ui.jsx';
import '../workspace/ws.css';

// /showcase/:token — "Partager ma vitrine" (migration 035): a company page
// and chosen products shared with a private contact. No sign-in: the
// link is the key. "Demander un prix" creates a request for that company
// without the visitor needing an account.
export default function ShowcasePublic() {
  const { token } = useParams();
  const { t, errorText } = useI18n();
  const [d, setD] = useState(null);
  const [error, setError] = useState('');
  const [picked, setPicked] = useState(null); // listing id, or 'company' for a general request
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const load = useCallback(() => api(`/showcase/${token}`).then(setD).catch((e) => setError(errorText(e))), [token, errorText]);
  useEffect(() => { load(); }, [load]);

  async function send() {
    setBusy(true); setError('');
    try {
      await api(`/showcase/${token}/request`, { method: 'POST', body: { listingId: picked === 'company' ? null : picked, name, email, message } });
      setDone(true);
    } catch (e) { setError(errorText(e)); } finally { setBusy(false); }
  }

  if (!d) return <div className="docview">{error ? <Alert>{error}</Alert> : <p className="muted">{t('common.loading')}</p>}</div>;
  return (
    <div className="docview">
      <div>
        {d.company?.logoUrl && <img src={d.company.logoUrl} alt="" style={{ maxHeight: 60 }} />}
        <h1 style={{ margin: '4px 0' }}>{d.company?.company || ''}</h1>
        {d.message && <p>{d.message}</p>}
      </div>
      {d.products.length > 0 && (
        <section className="ws-card">
          <h2>{t('ws.showcase.products')}</h2>
          <div className="ws-showcase-grid">
            {d.products.map((p) => (
              <div key={p.id} className={`ws-showcase-card${picked === p.id ? ' is-picked' : ''}`}>
                {p.photoUrl && <img src={p.photoUrl} alt="" />}
                <strong>{p.title}</strong>
                {p.description && <p className="small muted">{p.description}</p>}
                <button type="button" className="btn btn-primary btn-sm" onClick={() => setPicked(p.id)}>{t('ws.showcase.request')}</button>
              </div>
            ))}
          </div>
        </section>
      )}
      <section className="ws-card">
        <h2>{t('ws.showcase.requestGeneral')}</h2>
        {!picked && <button type="button" className="btn btn-ghost" onClick={() => setPicked('company')}>{t('ws.showcase.request')}</button>}
        {picked && !done && (
          <>
            <label className="field"><span className="field-label">{t('docView.name')}</span><input value={name} onChange={(e) => setName(e.target.value)} maxLength={120} /></label>
            <label className="field"><span className="field-label">{t('ws.cp.emailAddr')}</span><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={255} /></label>
            <label className="field"><span className="field-label">{t('docView.comment')}</span><textarea rows={3} value={message} onChange={(e) => setMessage(e.target.value)} maxLength={2000} /></label>
            <Alert>{error}</Alert>
            <div className="ws-actions"><button type="button" className="btn btn-primary" disabled={busy || name.trim().length < 2 || !email.includes('@') || !message.trim()} onClick={send}>{busy ? t('common.sending') : t('ws.showcase.send')}</button></div>
          </>
        )}
        {done && <p className="callout callout-success" role="status">{t('ws.showcase.requestSent')}</p>}
      </section>
    </div>
  );
}
